import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import ScrollProgress from "@/components/ScrollProgress";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Calculators from "@/pages/Calculators";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import Careers from "@/pages/Careers";
import GroutVisualizerPage from "@/pages/GroutVisualizerPage";
import { LanguageProvider } from "@/i18n/LanguageContext";

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen overflow-x-hidden bg-background text-foreground">
        <div className="grain-overlay" aria-hidden="true" />
        <BrowserRouter>
          <SmoothScroll>
            <ScrollProgress />
            <Nav />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/products" element={<Products />} />
                <Route path="/products/:slug" element={<ProductDetail />} />
                <Route path="/calculators" element={<Calculators />} />
                <Route path="/grout-visualizer" element={<GroutVisualizerPage />} />
                <Route path="/about" element={<About />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </main>
            <Footer />
          </SmoothScroll>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          theme="light"
          toastOptions={{
            style: {
              background: "#ffffff",
              border: "1px solid rgba(0,0,0,0.12)",
              borderRadius: 0,
              color: "#141414",
              fontFamily: "Montserrat, 'Noto Sans Devanagari', sans-serif",
            },
          }}
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
